import React from 'react';
import { useDocumentTitle } from './useDocumentTitle';

interface Props {
  html: string;
  title: string;
  description?: string;
}

/**
 * Renders a converted marketing page. The static content is injected as HTML
 * (it is build-time content from our own repo, not user input). Internal links
 * and modal triggers inside it are handled by the delegated click handler on
 * MarketingLayout's `.tgf` root, so navigation stays within the SPA.
 */
export const MarketingPage: React.FC<Props> = ({ html, title, description }) => {
  useDocumentTitle(title, description);
  return <div className="marketing-page" dangerouslySetInnerHTML={{ __html: html }} />;
};
